export default __webpack_public_path__ + "static/media/Glossary.639c51e1.svg";